// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js!./coc-styles-designSystem-bundle.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../node_modules/css-loader/dist/cjs.js!./tableStyles.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CSC Summit Design System reset styles */

.App {
  text-align: center;
}

/* responsive logo */
.coc-logo {
  -webkit-align-self: flex-center;
  -ms-flex-item-align: center;
  align-self: flex-center;
  -webkit-flex-shrink: 0;
  -moz-flex-shrink: 0;
  flex-shrink: 0;
  -webkit-box-flex: 0;
  -moz-box-flex: 0;
  -webkit-flex-grow: 0;
  flex-grow: 0;
  margin-left: -1rem;
  margin-right: 1.125rem;
  position: relative;
  width: 58px;
  height: 74px;
  display: inline-block;
  z-index: 1;
}

.coc-logo-mobile {
  display: block;
}

.coc-logo-desktop {
  display: none;
}

@media (min-width: 900px) {
  .coc-logo {
    -webkit-align-self: flex-start;
    -ms-flex-item-align: start;
    align-self: flex-start;
    margin-left: auto;
    /* margin-left: 1.125rem; */
    width: 144px;
    height: 68px;
  }

  .coc-logo-mobile {
    display: none;
  }

  .coc-logo-desktop {
    display: block;
  }
}

@media (min-width: 1200px) {
  .coc-logo {
    margin-right: 2.25rem;
    /* margin-left: 2.25rem; */
    width: 217px;
    height: 103px;
  }
}

@media print {
  .coc-logo {
    margin-left: 0;
    width: 144px;
    height: auto;
  }

  .coc-logo {
    display: inline-block;
    width: 144px;
    height: auto;
  }

  .coc-logo-mobile {
    display: none;
  }
}

/* Summit Design System overrides */
p {
  margin-bottom: inherit;
  max-width: min(60ch, 100%);
}

/* Accessibility: Limit text width to 60ch for better readability */
li {
  max-width: min(60ch, 100%);
}

/* breadcrumbs */
ol li {
  list-style: none;
}

/* pager */
.MuiPagination-ul li {
  list-style: none;
}

/* form error block */
ul {
  margin-bottom: revert;
}

/* spinner */
.preload-spinner-container {
  width: auto;
}

/* calendar control icon */
::-webkit-calendar-picker-indicator {
  filter: invert(50%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(100%)
    contrast(100%);
  cursor: pointer;
}

::-webkit-calendar-picker-indicator:hover {
  filter: invert(20%) sepia(100%) saturate(2000%) hue-rotate(0deg)
    brightness(100%) contrast(100%);
}
`, "",{"version":3,"sources":["webpack://./src/styles/App.css"],"names":[],"mappings":"AAAA,0CAA0C;;AAI1C;EACE,kBAAkB;AACpB;;AAEA,oBAAoB;AACpB;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,8BAA8B;IAC9B,0BAA0B;IAC1B,sBAAsB;IACtB,iBAAiB;IACjB,2BAA2B;IAC3B,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,qBAAqB;IACrB,0BAA0B;IAC1B,YAAY;IACZ,aAAa;EACf;AACF;;AAEA;EACE;IACE,cAAc;IACd,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,qBAAqB;IACrB,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,mCAAmC;AACnC;EACE,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA,mEAAmE;AACnE;EACE,0BAA0B;AAC5B;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;AAClB;;AAEA,UAAU;AACV;EACE,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,qBAAqB;AACvB;;AAEA,YAAY;AACZ;EACE,WAAW;AACb;;AAEA,0BAA0B;AAC1B;EACE;kBACgB;EAChB,eAAe;AACjB;;AAEA;EACE;mCACiC;AACnC","sourcesContent":["/* CSC Summit Design System reset styles */\n@import \"coc-styles-designSystem-bundle.css\";\n@import \"tableStyles.css\";\n\n.App {\n  text-align: center;\n}\n\n/* responsive logo */\n.coc-logo {\n  -webkit-align-self: flex-center;\n  -ms-flex-item-align: center;\n  align-self: flex-center;\n  -webkit-flex-shrink: 0;\n  -moz-flex-shrink: 0;\n  flex-shrink: 0;\n  -webkit-box-flex: 0;\n  -moz-box-flex: 0;\n  -webkit-flex-grow: 0;\n  flex-grow: 0;\n  margin-left: -1rem;\n  margin-right: 1.125rem;\n  position: relative;\n  width: 58px;\n  height: 74px;\n  display: inline-block;\n  z-index: 1;\n}\n\n.coc-logo-mobile {\n  display: block;\n}\n\n.coc-logo-desktop {\n  display: none;\n}\n\n@media (min-width: 900px) {\n  .coc-logo {\n    -webkit-align-self: flex-start;\n    -ms-flex-item-align: start;\n    align-self: flex-start;\n    margin-left: auto;\n    /* margin-left: 1.125rem; */\n    width: 144px;\n    height: 68px;\n  }\n\n  .coc-logo-mobile {\n    display: none;\n  }\n\n  .coc-logo-desktop {\n    display: block;\n  }\n}\n\n@media (min-width: 1200px) {\n  .coc-logo {\n    margin-right: 2.25rem;\n    /* margin-left: 2.25rem; */\n    width: 217px;\n    height: 103px;\n  }\n}\n\n@media print {\n  .coc-logo {\n    margin-left: 0;\n    width: 144px;\n    height: auto;\n  }\n\n  .coc-logo {\n    display: inline-block;\n    width: 144px;\n    height: auto;\n  }\n\n  .coc-logo-mobile {\n    display: none;\n  }\n}\n\n/* Summit Design System overrides */\np {\n  margin-bottom: inherit;\n  max-width: min(60ch, 100%);\n}\n\n/* Accessibility: Limit text width to 60ch for better readability */\nli {\n  max-width: min(60ch, 100%);\n}\n\n/* breadcrumbs */\nol li {\n  list-style: none;\n}\n\n/* pager */\n.MuiPagination-ul li {\n  list-style: none;\n}\n\n/* form error block */\nul {\n  margin-bottom: revert;\n}\n\n/* spinner */\n.preload-spinner-container {\n  width: auto;\n}\n\n/* calendar control icon */\n::-webkit-calendar-picker-indicator {\n  filter: invert(50%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(100%)\n    contrast(100%);\n  cursor: pointer;\n}\n\n::-webkit-calendar-picker-indicator:hover {\n  filter: invert(20%) sepia(100%) saturate(2000%) hue-rotate(0deg)\n    brightness(100%) contrast(100%);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
